<script>
  import { ignore, debounce } from '../../Common/tools';
  import { M } from '../../external';
  import SingleWallSettings from './SingleWall/SingleWallSettings.svelte';
  import MultipleWallsSettings from './MultipleWalls/MultipleWallsSettings.svelte';
  import getNewThread from './util/getNewThread';
  import Slider from '../../Common/Slider.svelte';

  export let widget,
    onChange = ignore,
    refreshUI = ignore;

  let data = widget.data,
    widgetUi = widget.$widget;

  const previousState = {
    single: null,
    multiple: null
  };

  const columnViewSplitOptions = [2, 3, 4, 5];

  const viewOptions = [
    { value: 'row-view', name: M.ROW_VIEW },
    { value: 'column-view', name: M.COLUMN_VIEW },
    { value: 'sidebar-view', name: M.SIDEBAR_VIEW }
  ];

  const kind = {
    selected: data.kind,
    options: [
      { kind: 'single', name: M.SINGLE_CHANNEL },
      { kind: 'multiple', name: M.MULTIPLE_CHANNELS }
    ],
    onChange: () => {
      if (data.kind === kind.selected) {
        return;
      }
      previousState[data.kind] = [...data.walls];
      kind.reset();
      data.kind = kind.selected;
      onChange();
      refreshUI();
    },
    reset: () => {
      if (previousState[kind.selected]) {
        data.walls = previousState[kind.selected];
      } else {
        const newWall = getNewThread();
        data.walls = [newWall];
      }
    }
  };

  const onFixedHeightValueChange = debounce((value) => {
    data.fixedHeightValue = value;
    onChange();
    if (data.isFixedHeight) {
      refreshUI();
    }
  }, 250);
</script>

<div class="popup-widget-wrapper">
  <h4 class="col20 f-left mt-15 mb-25 t-center h4-bigger">{M.DISCUSSION_THREADS}</h4>
  <div class="input-wrapper">
    <div class="info" style="width: 100%; margin-top: 5px">
      <h5>{M.SELECT_DISCUSSION_KIND}</h5>
    </div>
    <select class="col20 f-left" bind:value={kind.selected} on:change={kind.onChange}>
      {#each kind.options as kind}
        <option value={kind.kind}>{kind.name}</option>
      {/each}
    </select>
  </div>
  {#if data.kind === 'multiple'}
    <div class="input-wrapper">
      <div class="info" style="width: 100%; margin-top: 5px">
        <h5>{M.VIEW_STYLE}</h5>
      </div>
      <select
        class="col20 f-left"
        bind:value={data.view}
        on:change={() => {
          onChange();
          refreshUI();
        }}>
        {#each viewOptions as option}
          <option value={option.value}>{option.name}</option>
        {/each}
      </select>
    </div>

    {#if data.view === 'column-view'}
      <div class="input-wrapper">
        <div class="info" style="width: 100%; margin-top: 5px">
          <h5>{M.COLUMN_VIEW_SPLIT}</h5>
        </div>
        <select
          class="col20 f-left"
          bind:value={data.columnViewSplit}
          on:change={() => {
            onChange();
            refreshUI();
          }}>
          {#each columnViewSplitOptions as option}
            <option value={option}>{option}</option>
          {/each}
        </select>
      </div>
    {/if}
  {/if}

  {#if data.view === 'sidebar-view' && data.kind === 'multiple'}
    <div class="popup-input-wrapper">
      <h5>{M.DISCUSSION_BOARD_NAME}</h5>
      <input
        type="text"
        bind:value={data.boardName}
        on:blur={() => {
          onChange();
          refreshUI();
        }} />
    </div>
  {/if}

  {#if data.kind === 'single'}
    <SingleWallSettings wall={data.walls[0]} {onChange} {refreshUI} />
  {:else if data.kind === 'multiple'}
    <MultipleWallsSettings {data} {onChange} {refreshUI} />
  {:else}
    {data.kind}::NotImplemented
  {/if}
  <div class="popup-input-wrapper mb-0">
    <div class="checkbox-wrapper">
      <input
        id="isFixedHeight"
        bind:checked={data.isFixedHeight}
        on:change={() => {
          onChange();
          refreshUI();
        }}
        class="css-checkbox"
        type="checkbox"
        name="isFixedHeight" />
      <label for="isFixedHeight" class="css-label button-tooltip" data-original-title="" title="">
        {M.FIXED_HEIGHT}
        <span>{M.FIXED_HEIGHT_DESC}</span>
      </label>
    </div>
  </div>
  {#if data.isFixedHeight}
    <Slider label="{M.FIXED_HEIGHT}" suffix="%" value={data.fixedHeightValue} onChange={onFixedHeightValueChange} />
  {/if}
  <div class="popup-input-wrapper mb-0">
    <div class="checkbox-wrapper">
      <input
        id="isDarkTheme"
        bind:checked={data.isDarkTheme}
        on:change={() => {
          onChange();
          refreshUI();
        }}
        class="css-checkbox"
        type="checkbox"
        name="isDarkTheme" />
      <label for="isDarkTheme" class="css-label button-tooltip" data-original-title="" title=""
        >{M.USE_DARK_THEME}</label>
    </div>
  </div>
</div>
